import React from 'react'
import { ListGroup } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

const ResultsView = ({ employees }) => employees.length
  ? (
    <ListGroup>
      {employees.map(e => <ResultItem key={e.id} employee={e} />)}
    </ListGroup>
    )
  : <span>No results found.</span>

const ResultItem = ({ employee }) => {
  const { id, firstName, preferredName, lastName, jobTitle, department } = employee
  return (
    <LinkContainer to={`/person/${id}`}>
      <ListGroup.Item action>
        <span>{preferredName || firstName} {lastName}</span><br />
        <small>{jobTitle}</small>{' '}
        {department ? <small class='text-muted'>({department})</small> : null}
      </ListGroup.Item>
    </LinkContainer>
  )
}

export default ResultsView
